import { Module, Mutation, VuexModule, config } from "vuex-module-decorators";
import { IInstallEvent } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class DashboardModule extends VuexModule {
  installEvent: IInstallEvent | null = null;

  @Mutation
  setInstallEvent(event: IInstallEvent | null) {
    this.installEvent = event;
  }

  @Mutation
  clear() {
    this.installEvent = null;
  }
}
